<svg [attr.width]="diameter" [attr.height]="diameter" viewBox="0 0 50 50" class="spinner">
  <circle cx="25" cy="25" r="20" fill="none" [attr.stroke-width]="strokeWidth" />
</svg>